import axios from "axios"
import React, { useState } from "react"
import "../App.css"
import { SERVER_URI } from "../utility/config"

function AdminCreationKeyCreatedMessage(props) {
	window.setTimeout(function () {
		// Move to a new location
		props.handleClose()
	}, 1700)
	return (
		<div>
			<h2 className="message_title">Avain asetettu</h2>
		</div>
	)
}

function SetAdminCreationKey(props) {
	const [show, setShow] = useState(false)
	const [userData, setUserData] = useState({
		adminCreationKey: "",
	})
	let storage = window.localStorage
	let userToken = storage.getItem("admin_token")

	//Look at this closer

	const onChange = (e) => {
		setUserData({ ...userData, [e.target.name]: e.target.value })
	}

	// Submit
	const doSubmit = async (e) => {
		e.preventDefault()
		const dataToServer = userData
		try {
			await axios.post(`${SERVER_URI}/set_admin_creation_key/`, dataToServer, {
				headers: { Authorization: `Token ${userToken}` },
			})
			props.dispatch({
				type: "UPDATE_ADMIN_CREATION_KEY",
				data: { newKey: dataToServer },
			})
			setShow(!show)
		} catch (e) {
			console.log("Error in setting admin creation key.", e)
		}
	}
	return (
		<div className="popUp_card">
			<div className="popup-box">
				<div className="box">
					<span className="close-icon" onClick={props.handleClose}>
						x
					</span>
					{!show && (
						<div>
							<h2 className="popUp_title">Aseta uusi avain </h2>
							<form className="rejectionReason_form" onSubmit={(e) => doSubmit(e)}>
								<label className="label_add" htmlFor="rejectReason">
									Avain:
								</label>
								<input
									id="rejectReason"
									name="adminCreationKey"
									onChange={onChange}
									value={userData.adminCreationKey}></input>
								<br className="desktop-break" />
								<input type="submit" id="gradient_Button" value="Aseta avain" />
							</form>
						</div>
					)}
					{show && <AdminCreationKeyCreatedMessage handleClose={props.handleClose} />}
				</div>
			</div>
		</div>
	)
}

function AdminCreationKey(props) {
	props.stopListRefresh()
	const [isOpen, setIsOpen] = useState(false)
	//const [isloggedIn, setIsloggedIn] = useState(true);
	//let storage = window.localStorage;
	//let userToken = storage.getItem("admin_token")

	/* useEffect(() => {
        const fetchLogin = async () => {
            if (userToken === null) {
                console.log("kirjaudu sisään")
                setIsloggedIn(false)
            }
        }
        fetchLogin();
        // DON'T DELETE THE COMMENT BELOW!!
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []) */

	const togglePopUp = async () => {
		setIsOpen(!isOpen)
	}

	return (
		<div className="configurations">
			{isOpen && <SetAdminCreationKey dispatch={props.dispatch} currentKey={props.adminCreationKey} handleClose={togglePopUp} />}
			<h3>Avain admintunnuksen luontia varten</h3>
			<button id="gradient_Button" onClick={togglePopUp}>
				Aseta avain
			</button>
		</div>
	)
}

export default AdminCreationKey
